(function () {
  'use strict';

  var SECTION_SELECTOR = 'section[data-section-type="collection"]';
  var LIST_SELECTOR = '.product-list--collection';
  var CONTROL_ATTR = 'data-pvl-infinite-control';
  var states = new WeakMap();

  function getNextLink(section) {
    return section.querySelector('.collection__dynamic-part .pagination__next');
  }

  function getProductList(section) {
    return section.querySelector('.collection__dynamic-part ' + LIST_SELECTOR);
  }

  function getTotalItems(section) {
    var json = section.querySelector('[data-collection-products-count]');
    if (!json) return 0;
    try {
      var data = JSON.parse(json.textContent || '{}');
      return parseInt(data.totalItems, 10) || 0;
    } catch (error) {
      return 0;
    }
  }

  function productCount(section) {
    var list = getProductList(section);
    return list ? list.querySelectorAll(':scope > .product-item').length : 0;
  }

  function ensureControl(section) {
    var dynamicPart = section.querySelector('.collection__dynamic-part');
    var list = getProductList(section);
    if (!dynamicPart || !list) return null;

    var control = dynamicPart.querySelector('[' + CONTROL_ATTR + ']');
    if (control) return control;

    control = document.createElement('div');
    control.setAttribute(CONTROL_ATTR, '');
    control.className = 'pvl-infinite-catalogue';
    control.innerHTML = '<div class="pvl-infinite-catalogue__sentinel" aria-hidden="true"></div>' +
      '<p class="pvl-infinite-catalogue__status text--small" aria-live="polite"></p>' +
      '<button type="button" class="button button--secondary button--small pvl-infinite-catalogue__fallback" hidden>Load more products</button>';

    var pagination = dynamicPart.querySelector('.pagination');
    if (pagination) {
      pagination.insertAdjacentElement('afterend', control);
    } else {
      list.insertAdjacentElement('afterend', control);
    }
    return control;
  }

  function updateStatus(section, message) {
    var control = ensureControl(section);
    if (!control) return;
    var status = control.querySelector('.pvl-infinite-catalogue__status');
    if (!status) return;

    if (message) {
      status.textContent = message;
      return;
    }

    var loaded = productCount(section);
    var total = getTotalItems(section);
    var next = getNextLink(section);

    if (!next) {
      status.textContent = loaded ? (total && total >= loaded ? 'All ' + loaded + ' products loaded' : 'All products loaded') : '';
    } else if (total > loaded) {
      status.textContent = loaded + ' of ' + total + ' products loaded';
    } else {
      status.textContent = loaded + ' products loaded';
    }
  }

  function sectionFromResponse(html, sectionId) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var selector = SECTION_SELECTOR;
    if (sectionId) {
      try {
        var escaped = window.CSS && CSS.escape ? CSS.escape(sectionId) : sectionId.replace(/([#.;?+*~':"!^$\[\]()=>|\/@])/g, '\\$1');
        selector = 'section[data-section-type="collection"][data-section-id="' + escaped + '"]';
      } catch (error) {}
    }
    return doc.querySelector(selector) || doc.querySelector(SECTION_SELECTOR);
  }

  function replacePagination(currentSection, incomingSection) {
    var currentPagination = currentSection.querySelector('.collection__dynamic-part .pagination');
    var incomingPagination = incomingSection.querySelector('.collection__dynamic-part .pagination');

    if (incomingPagination) {
      if (currentPagination) {
        currentPagination.innerHTML = incomingPagination.innerHTML;
      } else {
        var list = getProductList(currentSection);
        if (list) list.insertAdjacentElement('afterend', incomingPagination.cloneNode(true));
      }
    } else if (currentPagination) {
      currentPagination.remove();
    }
  }

  function appendProducts(currentSection, incomingSection) {
    var currentList = getProductList(currentSection);
    var incomingList = getProductList(incomingSection);
    if (!currentList || !incomingList) return 0;

    var products = Array.prototype.slice.call(incomingList.children).filter(function (node) {
      return node.nodeType === 1 && node.classList.contains('product-item');
    });

    products.forEach(function (product) {
      currentList.appendChild(document.importNode(product, true));
    });
    return products.length;
  }

  function finish(section, state) {
    state.loading = false;
    section.classList.remove('pvl-infinite-catalogue--loading');
    var control = ensureControl(section);
    var next = getNextLink(section);

    updateStatus(section);

    if (!control) return;
    var sentinel = control.querySelector('.pvl-infinite-catalogue__sentinel');
    var fallback = control.querySelector('.pvl-infinite-catalogue__fallback');

    if (!next) {
      if (state.observer && sentinel) state.observer.unobserve(sentinel);
      if (fallback) fallback.hidden = true;
      return;
    }

    if (state.observer && sentinel) {
      state.observer.observe(sentinel);
    } else if (fallback) {
      fallback.hidden = false;
    }
  }

  function loadNext(section) {
    var state = states.get(section);
    if (!state || state.loading) return;

    var next = getNextLink(section);
    if (!next || !next.href) {
      finish(section, state);
      return;
    }

    var nextUrl = next.href;
    if (state.lastUrl === nextUrl) {
      // Safety guard against malformed pagination that points at the same page repeatedly.
      var pagination = section.querySelector('.collection__dynamic-part .pagination');
      if (pagination) pagination.remove();
      finish(section, state);
      return;
    }

    state.loading = true;
    state.lastUrl = nextUrl;
    section.classList.add('pvl-infinite-catalogue--loading');

    var control = ensureControl(section);
    var sentinel = control ? control.querySelector('.pvl-infinite-catalogue__sentinel') : null;
    var fallback = control ? control.querySelector('.pvl-infinite-catalogue__fallback') : null;
    if (state.observer && sentinel) state.observer.unobserve(sentinel);
    if (fallback) fallback.hidden = true;
    updateStatus(section, 'Loading more products…');

    fetch(nextUrl, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load next catalogue page');
      return response.text();
    }).then(function (html) {
      var incomingSection = sectionFromResponse(html, section.getAttribute('data-section-id'));
      if (!incomingSection) throw new Error('Catalogue section missing from response');

      var added = appendProducts(section, incomingSection);
      replacePagination(section, incomingSection);

      // Search pages can paginate mixed result types. If this page had no product cards,
      // keep moving until products are found or pagination ends.
      finish(section, state);
      if (added === 0 && getNextLink(section)) {
        window.setTimeout(function () { loadNext(section); }, 0);
      }
    }).catch(function () {
      state.loading = false;
      section.classList.remove('pvl-infinite-catalogue--loading');
      state.lastUrl = '';
      updateStatus(section, 'More products could not be loaded automatically.');
      if (fallback) {
        fallback.hidden = false;
        fallback.textContent = 'Try loading more products';
      }
    });
  }

  function initSection(section) {
    if (!getProductList(section)) return;

    var oldState = states.get(section);
    if (oldState && oldState.observer) oldState.observer.disconnect();

    section.classList.add('pvl-infinite-catalogue-ready');
    var control = ensureControl(section);
    if (!control) return;

    var state = { loading: false, lastUrl: '', observer: null };
    states.set(section, state);

    var sentinel = control.querySelector('.pvl-infinite-catalogue__sentinel');
    var fallback = control.querySelector('.pvl-infinite-catalogue__fallback');

    if ('IntersectionObserver' in window && sentinel) {
      state.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNext(section);
        });
      }, { rootMargin: '900px 0px' });
      state.observer.observe(sentinel);
      if (fallback) fallback.hidden = true;
    } else if (fallback) {
      fallback.hidden = !getNextLink(section);
      fallback.onclick = function () { loadNext(section); };
    }

    updateStatus(section);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  // Warehouse replaces the collection dynamic area after filters and sorting change.
  // Re-initialise against the newly-rendered product list each time that happens.
  document.addEventListener('theme:loading:end', function () {
    window.setTimeout(initAll, 0);
  });
})();
